import useUser from "../../users/hooks/useUser";
import { Route, Switch } from "wouter";
import AgendaPage from "../../agenda/containers/AgendaPage.tsx";
import DuplicateMerger from "../../patients/components/DuplicateMerger.tsx";
import PréférencesMainPanel from "../../preferences/components/PréférencesMainPanel.tsx";
import HorairesContainer from "../../horaires/containers/HorairesContainer.tsx";
import StatsContainer from "../../stats/containers/StatsContainer.tsx";
import UsersManagerContainer from "../../users/containers/UsersManagerContainer.tsx";
import Logout from "../../main/components/Logout.tsx";
import MessagesPage from "../../messages/components/MessagesPage.tsx";
import RulesMainComp from "../../rules/RulesMainComp.tsx";
import PatientsDuJour from "../../patients/components/PatientsDuJour.tsx";
import RemindersParams from "../../preferences/components/RemindersParams.tsx";
import PatientMainContainer from "../../patients/containers/PatientMainContainer.tsx";
import QuestionsMainContainer from "../../questions/QuestionsMainContainer.tsx";
import ActivePatients from "../../patients/components/PatientStates/ActivePatients.tsx";
import { ImportedEmailsPage } from "../../importedEmails/ImportedEmailsPage.tsx";
import CCAMBrowserTestPage from "../../ccam/containers/CCAMBrowserTestPage.tsx";
import RespondInboxPage from "../../respond/components/RespondInboxPage.tsx";
import PayrollTestPage from "../../payroll/components/PayrollTestPage.tsx";
import SecretaryContractsPage from "../../users/components/SecretaryContractsPage.tsx";
import ActesWizardTestPage from "../../actes/containers/ActesWizardTestPage.tsx";
import TherapeuticChoicesFeesPage from "../../therapeuticChoicesFees/components/TherapeuticChoicesFeesPage.tsx";
import DefaultMaterialsByActKindPage from "../../defaultMaterialsByActKind/components/DefaultMaterialsByActKindPage.tsx";
import PecStagingPage from "../../pec/PecStagingPage.tsx";
import TasksPage from "../../tasks/TasksPage.tsx";
import { TpePaymentsDayPage } from "../../tpePayments/containers/TpePaymentsDayPage.tsx";
import OrderingPage from "../../ordering/OrderingPage.tsx";
import ChecklistsPage from "../../checklists/ChecklistsPage.tsx";
import QuoteTrackingPage from "../../quotes/QuoteTrackingPage.tsx";

const AppSelectorContainer = () => {
  const user = useUser();

  return user ? (
    <Switch>
      <Route path="/" component={AgendaPage} />
      <Route path="/ccam" component={CCAMBrowserTestPage} />
      <Route path="/actes-wizard" component={ActesWizardTestPage} />
      <Route
        path="/therapeutic-choices-fees"
        component={TherapeuticChoicesFeesPage}
      />
      <Route
        path="/default-materials-by-act-kind"
        component={DefaultMaterialsByActKindPage}
      />
      <Route path="/fusion" component={DuplicateMerger} />
      <Route path="/prefs" component={PréférencesMainPanel} />
      <Route path="/reminders" component={RemindersParams} />
      <Route path="/horaires" component={HorairesContainer} />
      <Route path="/stats" component={StatsContainer} />
      <Route path="/quotes" component={QuoteTrackingPage} />
      <Route path="/users" component={UsersManagerContainer} />
      <Route path="/allmessages" component={MessagesPage} />
      <Route path="/rules" component={RulesMainComp} />
      <Route path="/todayPatients" component={PatientsDuJour} />
      <Route path="/activePatients" component={ActivePatients} />
      <Route path="/patient/:id" component={PatientMainContainer} />
      <Route path="/questions" component={QuestionsMainContainer} />
      <Route path="/importedEmails" component={ImportedEmailsPage} />
      <Route path="/pec-staging" component={PecStagingPage} />
      <Route path="/respond" component={RespondInboxPage} />
      <Route path="/payroll-test" component={PayrollTestPage} />
      <Route path="/secretary-contracts" component={SecretaryContractsPage} />
      <Route path="/tasks" component={TasksPage} />
      <Route path="/tpe-payments" component={TpePaymentsDayPage} />
      <Route path="/orders" component={OrderingPage} />
      <Route path="/checklists" component={ChecklistsPage} />
      <Route path="/logout" component={Logout} />
    </Switch>
  ) : null;
};

export default AppSelectorContainer;
